module.exports = __webpack_public_path__ + "static/about-e3ad7052f979cc398ad5ba53cc57879e.png";